<template>
<div class="">

  <v-container class="pb100">

    <v-dialog v-model="request_dialog" :width="450">
      <v-card>
        <v-card-title>Confirm Request</v-card-title>
        <v-card-text>
          Please confirm that you are requesting the release of {{selected_release_quantity}} videos per month
        </v-card-text>
        <v-card-actions class="grey lighten-3">

          <v-spacer></v-spacer>
          <v-btn text @click="request_dialog=false" v-if="!requesting_release">Cancel</v-btn>
          <v-btn dark color="green" @click="confirmRequest" :loading="requesting_release">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmed_dialog" :width="450">
      <v-card>
        <v-card-title>Thank you</v-card-title>
        <v-card-text>
          We have received your request. A member of our team will contact you shortly.
        </v-card-text>
        <v-card-actions class="grey lighten-3">

          <v-spacer></v-spacer>
          <v-btn color="blue" text dark to="/business/profile">Back to Contests</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row align="center" justify="center" v-if="contest.promo_poster && contest.promo_video_url">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card>
          <v-card-title class="secondary">
            <h5 class="white--text">Promotional material</h5>

          </v-card-title>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-container class="py-0">
                  <v-row>
                    <v-col cols="12" class="text-center py-0">
                      <h4>Poster</h4>
                    </v-col>
                    <v-col cols="12">
                      <img style="width:100%;height:auto" :src="contest.promo_poster" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" md="6">
                <v-container class="py-0">
                  <v-row>
                    <v-col cols="12" class="text-center py-0">
                      <h4>Video</h4>
                    </v-col>
                    <v-col cols="12">
                      <div class="video-responsive">
                        <iframe :src="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay allowfullscreen></iframe>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>



    <v-row align="center" justify="center" v-if="winner">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card>
          <v-card-title class="secondary">
            <h5 class="white--text">Contest winner</h5>
          </v-card-title>
          <project-tile :project="winner"></project-tile>
        </v-card>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" v-if="runnerUps.length">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card>
          <v-card-title class="secondary">
            <h5 class="white--text">Runner ups</h5>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-container class="">
            <v-row align="center">
              <v-col cols="6" sm="6" md="6" lg="6" class="py-0" v-for="(project,i) in runnerUps" :key="i">
                <project-tile :project="project"></project-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" v-if="excessVideos>0">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card>
          <v-card-title class="secondary">
            <h5 class="white--text">Release schedule available</h5>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="$eventBus.$emit('play_video',$store.state.app.tutorials.contest_report['Release schedule'])">
              <v-icon>fa-question</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row align="center" justify="end">
              <v-col cols="12" md="4">
                <v-text-field hide-details outlined label="Excess eligible videos available" :value="excessVideos" readonly type="number"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select hide-details outlined :items="releaseQuantities" v-model="selected_release_quantity" label="Select quantity per month"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field hide-details outlined label="Monthly invoice" v-model="monthly_invoice" prefix="$" readonly></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions class="grey lighten-3">
            <v-spacer></v-spacer>
            <v-btn class="px-4" color="primary" @click="purchase">Request</v-btn>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>

    <v-row v-if="contest.status > 0">
      <v-col cols="12" class="text-center">
        <v-btn color="green" dark :to="`/contests/${contest.id}/${contest.slug}`">View Contest</v-btn>
      </v-col>
    </v-row>

  </v-container>


</div>
</template>
<script>
import projectTile from "./project_tile"

function formatMoney(number, decPlaces, decSep, thouSep) {
  decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
    decSep = typeof decSep === "undefined" ? "." : decSep;
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return sign +
    (j ? i.substr(0, j) + thouSep : "") +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
    (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

export default {
  name: "",
  data: () => ({
    request_dialog: false,
    confirmed_dialog: false,
    selected_projects: [],
    selected_release_quantity: 1,
    price_per_video: 2000,
    loading: false,
    requesting_release: false,
    contest: {
      projects: []
    }
  }),
  created() {
    this.load()
  },
  components: {
    projectTile
  },
  methods: {
    async confirmRequest() {
      this.requesting_release = true;
      try {
        await this.$api({
          method: "POST",
          url: `/account/business/contests/${this.$route.params.id}/request-release`,
          data: {
            release_requested: this.selected_release_quantity
          }
        })
        this.confirmed_dialog = true;
        this.requesting_release = false;
        this.request_dialog = false
      } catch (ex) {
        alert(ex.error)
      }
      this.requesting_release = false;
    },
    purchase() {
      this.request_dialog = true
    },
    async load() {
      this.loading = true
      this.contest = await this.$api(`/account/business/contests/${this.$route.params.id}`)
      this.loading = false
    }
  },
  computed: {
    monthly_invoice() {
      return formatMoney(this.selected_release_quantity * this.price_per_video, 2, ".", ",")
    },
    releaseQuantities() {

      let excess = this.excessVideos
      return [1, 2, 4, 8, 10].filter(i => {
        if (i > excess) {
          return false
        } else {
          return true
        }
      })
    },
    excessVideos() {

      return this.contest.projects.filter(function(project) {
        if (project.status !== 3) {
          return false
        }
        return !this.contest.runner_ups.includes(project.id)
      }.bind(this)).length


    },
    winner() {
      return this.contest.projects.find(function(project) {
        return project.id === this.contest.winner
      }.bind(this))
    },
    runnerUps() {
      return this.contest.projects.filter(function(project) {
        if (project.id === this.contest.winner) {
          return false
        }
        return this.contest.runner_ups.includes(project.id)
      }.bind(this))
    },
    videoIframe() {
      return this.$helpers.iframeFromUrl(this.contest.promo_video_url)
    }
  }
}
</script>
<style lang="scss" scoped>
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
